import { Skeleton } from '@chakra-ui/react';

export const LoadingColorBox = () => {
  return <Skeleton w='full' borderRadius='2px' aspectRatio='1/1' />;
};
